import { FieldProps, getIn } from 'formik';
import * as React from 'react';
import { Form, FormGroup, OverlayTrigger } from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { FieldLabel, FormCol } from '../forms';
import FieldTooltip from './field-tooltip';
/*
   Παράδειγμα Λίστα με optional values απο τον user

import React, { useEffect, useState } from 'react';
import { FsProps } from 'components/common/formik/FsProps';
import { Field, useField } from 'formik';
import { CustomSelectComponent } from 'components/custom-select';

const options = [
  { value: 'collectionpoints', label: 'Σημεία Συλλογής' },
  { value: 'batteriescollections', label: 'Παραλαβές Μπαταριών' },
  { value: 'idocs', label: 'Έντυπα Αναγνώρισης' },
  { value: 'driversbatteriescollections', label: 'Καταχωρήσεις Οδηγών' },
];
export const FieldSelectAuditTableName = ({ label = 'Όνομα Στοιχείου', name = 'tableName', ...rest }: FsProps) => {
  //

  const [extraOptions, setExtraOptions] = useState([]);
  const [value] = useField(name);

  useEffect(() => {
    if (value && options.filter(v => v.value === value.value).length === 0) {
      const v = { value: value?.value, label: value?.value };
      setExtraOptions([...options, v]);
    } else setExtraOptions([...options]);

    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, []);
  return (
    <Field
      name={name}
      title={label}
      component={CustomSelectComponent}
      // options={[...options, ...extraOptions]}
      options={extraOptions}
      useCreatableSelect={true}
    />
  );
};
*/
const styles = {
  container: (base, state) => ({
    ...base,
    flex: 1,
    //display: 'inline-block',
    // width: '250px',
    minHeight: '1px',
    height: '26px',
    marginBottom: '0px',
    //textAlign: 'left',
    // border: 'none',
  }),
  control: (base, state) => ({
    ...base,
    height: '22px',
    minHeight: '22px',
    backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
    borderWidth: '1px',
    boxShadow: !state.isFocused
      ? 'inset 0 1px 1px #00000013'
      : '0 0 0 .2rem #007bff40',

    borderColor: '#ced4da',
    cursor: state.isDisabled ? 'not-allowed' : undefined,
    '&:hover': {
      borderColor: '#ced4da',
      //   borderColor: state.isFocused ? '#ced4da' : isInvalid ? '#dc3545' : '#ced4da',
    },
  }),
  input: (base, state) => ({
    ...base,
    minHeight: '1px',
    marginTop: '0px',
  }),
  indicatorsContainer: (base, state) => ({
    ...base,
    height: '22px',
    minHeight: '1px',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    paddingTop: '0',
    paddingBottom: '0',
    minHeight: '1px',
    color: state.isDisabled ? '#adb5bd' : undefined,
  }),
  indicatorSeparator: (base, state) => ({
    ...base,
    minHeight: '1px',
    height: '20px',
    marginTop: '0px',
    marginBottom: '0px',
  }),
  clearIndicator: (base, state) => ({
    ...base,
    paddingTop: '0',
    paddingBottom: '0',
    minHeight: '1px',
  }),
  valueContainer: (base, state) => ({
    ...base,
    minHeight: '1px',
    height: '22px',
    paddingTop: '0',
    paddingBottom: '0',
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#6c757d' : '#495057',
    minHeight: '1px',
    paddingTop: '1',
    paddingBottom: '1',
  }),
  loadingIndicator: (base, state) => ({
    ...base,
    paddingTop: '1',
    paddingBottom: '1',
    minHeight: '1px',
    color: '#007bff80',
  }),
  noOptionsMessage: (base, state) => ({
    ...base,
    color: '#dc3545',
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: 3,
    marginTop: '0px',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
  }),
  option: (base, state) => ({
    ...base,
    paddingTop: '4px',
    paddingBottom: '4px',
  }),
};

export const CustomSelectComponent = ({
  as = FormCol,
  className = 'mb-2',
  title,
  field, // { name, value, onChange, onBlur }
  form: { values, touched, errors, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  useCreatableSelect = false,
  disabled = false,
  helpText ='',
  ...props
}: FieldProps & {
  as?: any;
  className?: string;
  readonly title: string;
  readonly label: string;
  readonly options: ReadonlyArray<{
    readonly value: string;
    readonly label: string;
  }>;
  readonly useCreatableSelect?: boolean;
  readonly disabled?: boolean;
  readonly helpText?: string | React.ReactNode;
}) => {
  const { options } = props;
  const error = getIn(errors, field.name);
  const isTouched = getIn(touched, field.name);
  const showError = (isTouched || (submitCount ?? 0) > 0) && !!error;

  const controlStyleWithError = showError
    ? {
        ...styles,
        container: (base: any, state: any) => ({
          ...styles.container(base, state),
          marginBottom: '0px',
        }),
        control: (base: any, state: any) => ({
          ...styles.control(base, state),
          borderColor: '#dc3545',
          boxShadow: state.isFocused ? styles.control(base, state).boxShadow : 'none',
        }),
      }
    : styles;

  function initValue() {
    // eslint-disable-off-next-line-off functional/no-let
    let ret;
    if (values[field.name] === '') ret = '';
    else {
      if (options) {
        ret = options.find(
          (option) => option.value?.toString() === field.value?.toString()
        );
      } else ret = '';
    }
    return ret;
  }

  return (
    <FormGroup as={as} className={className}>
      <FieldLabel text={title} helpText={helpText} />
      <OverlayTrigger
        delay={{ show: 400, hide: 400 }}
        overlay={
          <FieldTooltip
            text={field.name}
            value={field.value == null ? '' : String(field.value)}
          />
        }
        placement="top"
      >
        <div>
          {!useCreatableSelect ? (
            <Select
              {...field}
              {...props}
              options={options}
              value={initValue()}
              onChange={(option) =>
                setFieldValue(field?.name, (option as any)?.value)
              }
              styles={controlStyleWithError}
              isClearable={props.isClearable ?? true}
              placeholder={''}
              isDisabled={disabled}
            />
          ) : (
            <CreatableSelect
              {...field}
              {...props}
              options={options}
              value={
                (values[field.name] === ''
                  ? ''
                  : options
                  ? options.find((option) => option.value === field.value)
                  : '') as any
              }
              onChange={(option) =>
                setFieldValue(field?.name, (option as any)?.value)
              }
              styles={controlStyleWithError}
              isClearable={props.isClearable ?? true}
              placeholder={''}
              isDisabled={disabled}
            />
          )}
          {showError && (
            <Form.Control.Feedback className="d-block mt-0" type="invalid">
              {String(error)}
            </Form.Control.Feedback>
          )}
        </div>
      </OverlayTrigger>
    </FormGroup>
  );
};
